import { useDataProvider } from "@hooks/data/useDataProvider";
import Lightdash from "@lightdash/sdk";
import { useCallback, useEffect, useMemo, useState } from "react";

export interface IEmbeddedReportProps {
  dashboardId: string;
  canDateZoom: boolean;
}

export const EmbeddedReport: React.FC<IEmbeddedReportProps> = ({
  dashboardId,
  canDateZoom,
}) => {
  const dataProvider = useDataProvider();
  const dataProviderInstance = useMemo(() => dataProvider(), [dataProvider]);

  const [baseUrl, setBaseUrl] = useState<string>("");
  const [embedToken, setEmbedToken] = useState<string>("");

  const getEmbedToken = useCallback(async () => {
    const baseUrl = dataProviderInstance.getApiUrl();

    return await dataProviderInstance.custom<{
      baseUrl: string;
      token: string;
    }>?.({
      method: "get",
      url: `${baseUrl}/Reports?dashboardId=${dashboardId}&canDateZoom=${canDateZoom}`,
    })
      .then((result) => {
        setBaseUrl(result?.data.baseUrl);
        setEmbedToken(result?.data.token);
      })
      .catch((err) => console.error("Failed to load dashboard:", err));
  }, [dataProviderInstance, dashboardId, canDateZoom]);

  useEffect(() => {
    getEmbedToken();
  }, [dashboardId, canDateZoom]);

  return embedToken ? (
    <>
      <Lightdash.Dashboard instanceUrl={baseUrl} token={embedToken} />
    </>
  ) : (
    <div>Loading...</div>
  );
}